import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <BrowserRouter>
          <Routes>
              <Route path="*" element={<App />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
      </BrowserRouter>
  </React.StrictMode>
);
